import { TOptions } from "i18next";
import { useTranslation } from "react-i18next";

const useI18n = () => {
  const { t } = useTranslation();
  return (key: string, params?: TOptions) => t(key, params ?? {}) ?? 'translation not found';
}

export default useI18n;
